import { Route, Routes } from "react-router-dom";
import * as routes from "../routes";

import ProtectedRoute from "./ProtectedRoute";

import SocietyController from "../../pages/SocietyController/SocietyController";
import MasterLayout from "../../masterLayout/SocietyController/MasterLayout";
import { Dashboard as SocietyControllerDashboard } from "../../pages/SocietyController/Dashboard/Dashboard";

import Login from "../../pages/SocietyController/Auth/Login/Login";
import ForgotPassword from "../../pages/SocietyController/Auth/Login/ForgotPassword";

import SocietyMangement from "../../pages/SocietyController/SocietyManagement/SocietyMangement";
import CreateSocietyMangement from "../../pages/SocietyController/SocietyManagement/CreateSocietyMangement";
import SettingSocietyMangement from "../../pages/SocietyController/SocietyManagement/SettingSocietyMangement";
import CommunicationSettings from "../../pages/SocietyController/SocietyManagement/CommunicationSettings";
import SmsCreditRequest from "../../pages/SocietyController/SmsCreditRequest/SmsCreditRequest";
import SmsCreditPackage from "../../pages/SocietyController/SMSCreditPackage/SmsCreditPackage";

import Brand from "../../pages/SocietyController/Brand/Brand";
import CreateBrand from "../../pages/SocietyController/Brand/CreateBrand";
import EditBrand from "../../pages/SocietyController/Brand/EditBrand";

import Location from "../../pages/SocietyController/Location/Location";
import GateKeeperLogin from "../../pages/SocietyController/GateKeeperLogin/GateKeeperLogin";
import AdminUsers from "../../pages/SocietyController/AdminUsers/AdminUsers";
import ManageUsers from "../../pages/SocietyController/ManageUsers/ManageUsers";
import ManageEmployee from "../../pages/SocietyController/ManageEmployee/ManageEmployee";
import EmployeeTypes from "../../pages/SocietyController/EmployeeTypes/EmployeeTypes";
import RolesPermissions from "../../pages/SocietyController/RolesPermissions/RolesPermissions";
import ManageVendor from "../../pages/SocietyController/ManageVendor/ManageVendor";
import ManageTenant from "../../pages/SocietyController/ManageTenant/ManageTenant";

import ViewProfilePage from "../../pages/SocietyController/Profile/ViewProfilePage";
import ComplaintCategoriesController from "../../pages/SocietyController/ComplaintCategories/ComplaintCategories";

const strip = (path) => path.replace(/^\//, "");

// Optional permission gate placeholder. Society Controller is the super-admin
// surface today (auth gated by `is_super_admin` on AdminData), so no per-page
// permission checks are wired up yet. When the controller permission model
// lands, mirror the SocietyPortal/PermissionOnComponent pattern here and wrap
// element props with `guard([...])` like in SocietyPortal/Routers.js.

const SocietyControllerRouter = () => (
  <Routes>
    {/* Public auth routes */}
    <Route path={strip(routes.LOGIN)} element={<Login />} />
    <Route path={strip(routes.FORGOT_PASSWORD)} element={<ForgotPassword />} />

    {/* Authenticated controller surface */}
    <Route element={<SocietyController />}>
      <Route element={<ProtectedRoute />}>
        <Route element={<MasterLayout />}>
          <Route index element={<SocietyControllerDashboard />} />
          <Route path={strip(routes.SOCIETY_MANAGEMENT)} element={<SocietyMangement />} />
          <Route
            path={strip(routes.SOCIETY_MANAGEMENT_CREATE)}
            element={<CreateSocietyMangement />}
          />
          <Route
            path={strip(routes.SOCIETY_MANAGEMENT_EDIT)}
            element={<CreateSocietyMangement />}
          />
          <Route
            path={strip(routes.SOCIETY_MANAGEMENT_SETTINGS)}
            element={<SettingSocietyMangement />}
          />
          <Route
            path={strip(routes.SOCIETY_MANAGEMENT_COMMUNICATION_SETTINGS)}
            element={<CommunicationSettings />}
          />
          <Route path={strip(routes.SMS_CREDIT_REQUEST)} element={<SmsCreditRequest />} />
          <Route path={strip(routes.SMS_CREDIT_PACKAGE)} element={<SmsCreditPackage />} />
          <Route path={strip(routes.SOCIETY_BRAND)} element={<Brand />} />
          <Route path={strip(routes.SOCIETY_BRAND_CREATE)} element={<CreateBrand />} />
          <Route path={strip(routes.SOCIETY_BRAND_EDIT)} element={<EditBrand />} />
          <Route path={strip(routes.SOCIETY_LOCATION)} element={<Location />} />
          <Route path={strip(routes.SOCIETY_GATEKEEPER)} element={<GateKeeperLogin />} />
          <Route path={strip(routes.SOCIETY_ADMIN_USER)} element={<AdminUsers />} />
          <Route path={strip(routes.SOCIETY_MANAGE_USERS)} element={<ManageUsers />} />
          <Route path={strip(routes.SOCIETY_MANAGE_EMPLOYEES)} element={<ManageEmployee />} />
          <Route path={strip(routes.SOCIETY_EMPLOYEE_TYPES)} element={<EmployeeTypes />} />
          <Route path={strip(routes.SOCIETY_ROLES_PERMISSIONS)} element={<RolesPermissions />} />
          <Route path={strip(routes.SOCIETY_MANAGE_VENDORS)} element={<ManageVendor />} />
          <Route path={strip(routes.SOCIETY_MANAGE_TENANTS)} element={<ManageTenant />} />
          <Route path={strip(routes.SOCIETY_CTRL_COMPLAINT_CATEGORIES)} element={<ComplaintCategoriesController />} />
          <Route path={routes.SOCIETY_PROFILE} element={<ViewProfilePage />} />
        </Route>
      </Route>
    </Route>

    {/* Standalone duplicate kept from prior config (matches existing behaviour) */}
    <Route path={strip(routes.SOCIETY_MANAGEMENT)} element={<SocietyMangement />} />
  </Routes>
);

export default SocietyControllerRouter;
